import axios from 'axios';
import Logger from "../util/Logger";
import {Response} from "./Response";

export class RestApiService {

    static BASE_URL = process.env.REACT_APP_API_URL;

    static async postMultipart(apiEndpoint, token, formData) {
        Logger.info("uploading file to [" + apiEndpoint + "]");
        let api = axios.create({baseURL: this.BASE_URL});
        try {
            const response = await api.post(apiEndpoint,
                formData,
                {
                    headers: {
                        'Content-type': 'multipart/form-data',
                        'Authorization': 'Bearer ' + token
                    }
                });

            Logger.info("file was successfully uploaded", response);
            return new Response(response.status, response.data);
        } catch (exception) {
            return await this.handleError(apiEndpoint, exception);
        }
    }


    static async post(apiEndpoint, formData, headers = {}) {
        Logger.info("sending data to [" + apiEndpoint + "] ");
        let api = axios.create({baseURL: this.BASE_URL});
        try {
            const response = await api.post(apiEndpoint,
                formData,
                {
                    headers: headers
                });

            Logger.info("response was successfully received", response);
            return new Response(response.status, response.data);
        } catch (exception) {
            return await this.handleError(apiEndpoint, exception);
        }
    }


    static async put(apiEndpoint, formData, headers = {}) {
        Logger.info("sending data to [" + apiEndpoint + "]");
        let api = axios.create({baseURL: this.BASE_URL});
        try {
            const response = await api.put(apiEndpoint,
                formData,
                {
                    headers: headers
                });

            Logger.info("response was successfully received", response);
            return new Response(response.status, response.data);
        } catch (exception) {
            return await this.handleError(apiEndpoint, exception);
        }
    }


    static async get(apiEndpoint, headersOb = {}, paramOb = {}) {
        Logger.info("sending data to [" + apiEndpoint + "] ", process.env);
        let api = axios.create({baseURL: this.BASE_URL});

        let config = {
            headers: headersOb,
            params: paramOb,
        };

        try {
            const response = await api.get(apiEndpoint, config);
            Logger.info("response was successfully received", response);
            return new Response(response.status, response.data);
        } catch (exception) {
            return await this.handleError(apiEndpoint, exception);
        }
    }


    static async delete(apiEndpoint, headersOb = {}, paramOb = {}) {
        Logger.info("sending data to [" + apiEndpoint + "] ", process.env);
        let api = axios.create({baseURL: this.BASE_URL});

        let config = {
            headers: headersOb,
            params: paramOb,
        };

        try {
            const response = await api.delete(apiEndpoint, config);
            Logger.info("response was successfully received", response);
            return new Response(response.status, response.data);
        } catch (exception) {
            return await this.handleError(apiEndpoint, exception);
        }
    }


    static async handleError(apiEndpoint, exception) {
        Logger.info("error while making the request for the endpoint [" + apiEndpoint + "]. error :", exception.response);

        let status = 500;
        let data = {
            message: "Something went wrong! Please try again shortly"
        };
        if (exception.response !== null && exception.response !== undefined) {
            status = exception.response.status;
            data = exception.response.data;
        }
        return new Response(status, data);

    }
}